import { inject, Injectable } from '@angular/core';
import { THEME } from '@constants/app.constants';
import { LOCAL_STORAGE_CONSTANT } from '@constants/localstorage.constant';
import { Theme } from '@db-models/worker-db.model';
import { WorkerService } from '@feature-services/worker.service';
import { LocalStorageService } from '@util-services/local-storage.service';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {

  private workerService = inject(WorkerService);
  private storageService = inject(LocalStorageService);

  public currentTheme: Theme = THEME.OLD as Theme;
  public lastUiViewValue: 'mobile' | 'tablet' | 'laptop';
  public lastTextLabelValue: boolean;
  getCurrentTheme = new Subject<any>();

  constructor() {
    document.documentElement.style.setProperty('--calenso-font-color', `hsl(222.2, 84%, 4.9%)`);
  }

  getThemeKey(): string {
    const loggedInWorker = this.workerService.getLoggedInWorkerFromLocalStorage();
    return loggedInWorker ? `${LOCAL_STORAGE_CONSTANT.CURRENT_THEME}_${loggedInWorker.uuid}` : '';
  }

  public loadTheme(): void {
    this.currentTheme = THEME.OLD;
    this.getCurrentTheme.next(this.currentTheme);
  }

  public saveTheme(): void {
    const themeKey = this.getThemeKey();
    this.storageService.set(themeKey, String(this.currentTheme));
    this.getCurrentTheme.next(this.currentTheme);
  }

  toggleTheme(_themeValue: Theme): void {
    // No-op: theme toggle disabled
  }

  setUpTheme(_activeTheme = THEME.OLD): void {
    this.currentTheme = THEME.OLD;
    this.saveTheme();
  }
}
